module.exports = __webpack_public_path__ + "static/img/BMI.f4904741.svg";